import { omit } from 'lodash';
import { get, patch, post, put } from './utils';

export async function getNicheByIdApi(id) {
  return get(`/niches/${id}`);
}

export async function getOrderHistoryApi(id) {
  return get(`/orderHistories/orders/${id}`);
}

export async function acceptOrderHistoryApi(id, isAccept, data) {
  return put(`/orderHistories/${id}/isAccept/${isAccept}`, data);
}

export async function forceFeedbackApi(id, data) {
  return put(`/orderHistories/${id}/forceFeedback`, data);
}

export async function checkPriceOrderApi(data) {
  return post('/orders/check-price', data);
}

export async function getShippingFeeApi(data) {
  return post('/orders/get-shipping-fee', data);
}

export async function createOrderWithImportApi(data) {
  return post('/orders/bulk', data);
}

export async function calculateShippingFeeApi(data) {
  return post('/delivery/calculate-fee', data);
}

export async function getOriginalOrderApi(data) {
  return post('/orders-return/origin-order', data);
}

export async function importOrdersApi(data) {
  return post(`/orders/import`, data);
}

export async function cancelOrdersApi(data) {
  return post(`/orders/cancel/${data?.orderId}`, omit(data, 'orderId'));
}

export async function orderOverview() {
  return get(`/orders/overview`);
}

export async function getVendorFfmSummaryApi() {
  return get(`/orders/fulfillment/summary/status`);
}

export const replaceSkuApi = ({ id, data }) => {
  return put(`/orders/${id}/edit-items`, data);
};

export const commentReturnApi = ({ id, data }) =>
  post(`/return-orders/${id}/comment`, data);

export async function confirmOrderApi({ data, id }) {
  return post(`/orders/${id}/confirm`, data);
}
export async function cancelOrderApi({ id, data }) {
  return post(`/orders/${id}/cancel`, data);
}

export async function getOrderByIdApi(id) {
  return get(`/orders/${id}?join=payments&includeErpAmount=true`);
}

export async function refreshOrderApi({ id, data }) {
  return put(`/orders/${id}/refresh`, data);
}

export const confirmForcePaymentApi = ({ id, data }) =>
  put(`/orders/${id}/confirm-success-payment`, data);

export const confirmForceToCODApi = ({ id }) =>
  post(`/orders/${id}/change-to-cod`, {});

export const exportWSApi = ({ id }) =>
  post(`/orders/${id}/batch-warehouse-shipment`);

export const markDeliverySuccessApi = (id) =>
  post(`/orders/${id}/mark-order-delivery-success`);

export const completePickApi = ({ id }) =>
  post(`/order-batches/${id}/pick-complete`);

export const moveToLostApi = ({ id }) => patch(`/orders/${id}/move-to-lost`);

export const moveToPendingApi = ({ id, data }) =>
  post(`/orders/${id}/pending`, data);

export const revertToPreviousStateApi = ({ id }) =>
  post(`/pending-order/${id}/revert-status`, {});

export const failQCApi = ({ id, data }) => put(`/orders/${id}/fail-qc`, data);
export const passQCApi = ({ id, data }) => put(`/orders/${id}/pass-qc`, data);

export const moveToReadyToPickApi = ({ id }) =>
  post(`/pending-order/${id}/move-to-ready-to-pick`, {});

export const editInvoiceInformationApi = ({ id, data }) => {
  return post(`/orders/${id}/edit-invoice`, data);
};

export const editDeliveryInformationApi = ({ id, data }) => {
  return post(`/orders/${id}/edit-shipping-information`, data);
};

export const getBatchLabelApi = async (batchId) => {
  const job = await post(`/label/batch/${batchId}/bulk-print-marketplace`, {});

  return new Promise((resolve) => {
    let interval = null;
    const timeout = setTimeout(() => {
      interval && clearInterval(interval);
      resolve({ error: 'timeout' });
    }, 300000); // 5 minutes in milliseconds
    getBatchJobApi(job?.jobId).then((checking) => {
      if (checking.status === 'COMPLETED') {
        clearTimeout(timeout);
        clearInterval(interval);
        resolve(checking);
      }
    });
    interval = setInterval(async () => {
      const checking = await getBatchJobApi(job?.jobId);
      if (checking.status === 'COMPLETED') {
        clearTimeout(timeout);
        clearInterval(interval);
        resolve(checking);
      }
    }, 10000);
  });
};

export const getBatchJobApi = (jobId) => {
  return get(`/label/job-bulk-print-marketplace/${jobId}`, {});
};

export async function confirmRefundApi({ id, data }) {
  return post(`/orders/${id}/payment/refund`, data);
}

export async function getDeliveryTypesApi() {
  return get(`/delivery/types-available`);
}

export async function markAsRefundApi({ id, data }) {
  return post(`/orders/${id}/mark-as-refund`, data);
}

export const markAsCompleteApi = ({ id }) =>
  put(`/orders/${id}/mark-as-completed`);

export const editPickupInformationApi = ({ id, data }) =>
  put(`/orders/${id}/edit-pickup-location`, data);

export const createShippingNoApi = ({ id }) =>
  put(`/orders/${id}/force-delivery`);
